import React from 'react';
import {Pill, OutlinedPillVariant} from '@forecast-it/design-system';
import {SaveState} from '../shared/saveState';

// Placeholder copy — not localised yet; must go through the translations workflow.
const LABEL_BY_STATE: Record<SaveState, string> = {
	[SaveState.Saved]: 'Saved',
	[SaveState.Saving]: 'Saving…',
	[SaveState.Unsaved]: 'Unsaved changes',
	[SaveState.Error]: 'Save failed',
};

const VARIANT_BY_STATE: Record<SaveState, OutlinedPillVariant> = {
	[SaveState.Saved]: OutlinedPillVariant.SUCCESS,
	[SaveState.Saving]: OutlinedPillVariant.ACTIVE,
	[SaveState.Unsaved]: OutlinedPillVariant.NEUTRAL,
	[SaveState.Error]: OutlinedPillVariant.ERROR,
};

export function SaveStatePill({saveState}: {saveState: SaveState}): JSX.Element {
	return (
		<span data-cy="nova-save-state">
			<Pill outlined outlinedVariant={VARIANT_BY_STATE[saveState]}>
				{LABEL_BY_STATE[saveState]}
			</Pill>
		</span>
	);
}
